
import { Options, mixins } from "vue-class-component";
import { Header } from "@/mixins";
import Logo from "@/components/ui/BaseIcons/Logo.vue";
import MenuBtn from "./BaseButtonHamburger/index.vue";
import HeaderMenu from "./TheHeaderMenu/index.vue";
import HeaderMetaInfo from "./TheHeaderMetaInfo.vue";
import StoreBtn from "./BaseButtonStore/index.vue";
import DiscordButton from "./BaseButtonDiscord/index.vue";
import ShopBtn from "./BaseButtonShop.vue";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import { useMq } from "vue3-mq";
import HeaderMenuMobile from "./TheHeaderMenuMobile/index.vue";

@Options({
  name: "headerComponent",
  components: {
    Logo,
    MenuBtn,
    HeaderMenu,
    StoreBtn,
    DiscordButton,
    ShopBtn,
    SvgIcon,
    HeaderMetaInfo,
    HeaderMenuMobile,
  },
  watch: {
    "$route.fullPath"() {
      this.isMobileMenuOpen = false;
    },
  },
})
export default class HeaderComponent extends mixins(Header) {
  $refs!: {
    header: HTMLElement;
    menuButton?: { $el: HTMLButtonElement };
  };

  protected mq = useMq();
  protected isMobileMenuOpen = false;

  protected get isDesktop(): boolean {
    return ["lg", "xl", "xxl"].includes(this.mq.current);
  }

  protected get isMobile(): boolean {
    return ["xs", "sm", "md"].includes(this.mq.current);
  }

  private resizeHandler(): void {
    if (!this.isMobile) {
      this.isMobileMenuOpen = false;
    }
  }

  protected toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  protected closeMobileMenu(): void {
    if (!this.isMobileMenuOpen) return;

    this.isMobileMenuOpen = false;
    this.$nextTick(() => this.$refs.menuButton?.$el?.focus());
  }

  beforeMount() {
    window.addEventListener("resize", this.resizeHandler);
  }

  beforeUnmount() {
    window.removeEventListener("resize", this.resizeHandler);
  }
}
